import React, { Component } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink, Button, Modal, ModalHeader, Row, Col, ModalBody } from "reactstrap";
import { Modal as ModalPopup } from "react-bootstrap";
import { AxiosError, AxiosResponse } from "axios";
// import InteractionHistory from "./InteractionHistory";
import DynamicListView from "../CommonComponentListView/DynamicListView";
import Service from "../../../services";
import { InteractionHistoryModal } from "../../../models/InteractionHistoryModel";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import { catchError } from "../../../utils/Utils";
import { timeConversion, removeMilliSeconds } from "../../../utils/GeneralUtils"
import FilterIcon from "../../../images/filter-icon.svg";
import FilterLeads from "../../Filters/FilterLeads";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { ColumnConfig, FileData, documentsData } from "../../../models/ActionModel";
import { clearFilters, getFilterValue, setFilters } from "../../Filters/FiltersHelper";
import FinSpinner from "../../../commonfields/FinSpinner";
import ReactFileViewer from "../../../commonfields/ReactFileViewer";
import { fileFormatSupported } from "../../../utils/GeneralUtils";
import { toast } from "react-toastify";
import { Pages, actionAuthorization } from "../../../utils/RolesUtil";
import { withContext } from "../../Authentication/RoleAuthorizationClassComponent";
import { BankUserContext } from "../../../bankUserContext";




interface initialProps {
  refreshComponent: boolean;
  context: any;
}

interface customerActivity {
  name: string;
  sessionTime: string;
  sessionStart: string;
  sessionEnd: string;
  Date: string;
}

interface InteractionHistorystate {
  activeTab: string;
  completedActions: InteractionHistoryModal[] | [];
  customerActivity: customerActivity[];
  columnNames: ColumnConfig[];
  filterModal: boolean;
  filtersData: any;
  selectedFilters: any;
  pageName: string;
  loader: boolean;
  viewFile: boolean;
  documentsData: documentsData | null;
}
const notesAndDocumentsData = [
  { text: "Has Notes", value: 1 },
  { text: "Has Documents", value: 2 },
]

class InteractionHistoryMainCC extends Component<WithRouterProps<initialProps>, InteractionHistorystate> {
  service: Service;
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  constructor(props: any) {
    super(props);
    this.state = {
      activeTab: "1",
      completedActions: [],
      customerActivity: [

      ],
      columnNames: [
        { label: "contact", displayText: 1, columnStyling: "", orderId: 1, displayLabelText: "CONTACT" },
        { label: "interaction", displayText: 1, columnStyling: "", orderId: 2, displayLabelText: "INTERACTION" },
        { label: "dateCreated", displayText: 1, columnStyling: "", orderId: 3, displayLabelText: "DATE CREATED" },
        {
          label: "dateCompleted",
          displayText: 1,
          columnStyling: "",
          condition: this.canceledColumnStyling,
          orderId: 4,
          displayLabelText: "DATE COMPLETED"
        },
        {
          label: "action",
          displayText: 1,
          columnStyling: "",
          textStyling: "",
          orderId: 5,
          displayLabelText: "ACTION"
        },
        {
          label: "reassign",
          displayText: 1,
          columnStyling: "",
          textStyling: "",
          orderId: 6,
          displayLabelText: "ASSIGNED TO"
        },
        {
          label: "product",
          displayText: 1,
          columnStyling: "interactionHistory",
          textStyling: "",
          orderId: 7,
          displayLabelText: "PRODUCT"
        },
        {
          label: "actionNotes",
          displayText: 2,
          columnStyling: "optionsContainer",
          operation: this.imgOnclickFunction,
          orderId: 8,
          displayLabelText: "NOTES"
        },
        {
          label: "documents",
          displayText: 2,
          columnStyling: "optionsContainer",
          orderId: 9,
          displayLabelText: "DOCUMENTS",
          condition: this.openFileViewer
        }
      ],
      filterModal: false,
      filtersData: [],
      selectedFilters: {},
      pageName: "interactionHistory",
      loader: false,
      viewFile: false,
      documentsData: null

    };
    this.service = new Service();

  }

  getInteractionHistoryParentFiltersData = () => {
    this.getFiltersDataProperties();
    const filters = getFilterValue(this.state.pageName)
    if (filters) {
      const newFiltersData = {
        campaigns: filters?.campaigns?.map((m: any) => m.value),
        contacts: filters?.contacts?.map((m: any) => m.value),
        interactions: filters?.interactions?.map((m: any) => m.text),
        products: filters?.products?.map((m: any) => m.value),
        notesAndDocuments: filters?.notesAndDocuments ?? null,
        date: filters?.date
          ? moment(filters?.date).format("MM/DD/YYYY")
          : null,
      };
      this.setState({ selectedFilters: filters })
      this.getInteractionHistory(newFiltersData)
    } else {
      this.getInteractionHistory();
    }
    
  }

  componentDidMount(): void {
    this.getInteractionHistoryParentFiltersData();
  }
  componentWillUnmount(): void {
    localStorage.removeItem("status");   //removing status from local storage
  }
  modifyFiltersData = (filtersDataObj: any, data: any) => {
    const keys = Object.keys(filtersDataObj);
    if (keys?.length > 0) {
      keys.forEach((key: any) => {
        if (filtersDataObj[key] != null && filtersDataObj[key]?.length > 0) {
          data[key] = filtersDataObj[key];
        }
      });
    }
  };

  openFileViewer = (document: any) => {
    this.setState({ loader: true })
    this.service.getDocuments(document.documentUniqueId).then((response: AxiosResponse<FileData>) => {
      if (fileFormatSupported(response?.data?.fileType)) {
        const documentObject = {
          fileName: response.data.fileName,
          fileType: response.data.fileType,
          uri: `${response.data.fileContent}`,
        }
        this.setState({ documentsData: documentObject, viewFile: true })
      } else {
        toast.error("FileView is not supported");
      }
    }).catch((error: AxiosError) => {
      catchError(error, true);
    }).finally(() => {
      this.setState({ loader: false })
    })
  }

  getClientActivityData = () => {
    const data = {
      screen: "CustomerDetails",
      sections: "getClientLogsByClientId",
      clientId: this.props.params.clientId,
      isJsonReturnObject: false
    }
    this.setState({ loader: true })
    this.service
      .getClientActivity(data)
      .then((response: any) => {
        this.setState({ customerActivity: response.data })
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      }).finally(() => {
        this.setState({ loader: false })
      });


  }

  getInteractionHistory = (selectedFilters?: any) => {
    const data = {
      screen: "ProspectDetails",
      sections: "GetClientActionsInteractionHistoryList",
      clientId: this.props.params.clientId,
      isJsonReturnObject: false,
    };
    selectedFilters && this.modifyFiltersData(selectedFilters, data);
    this.setState({ loader: true })
    this.service
      .getInteractionHistoryData(data)
      .then((response: AxiosResponse<InteractionHistoryModal[]>) => {
        this.setState({ completedActions: response.data })
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      }).finally(() => {
        this.setState({ loader: false })
      });
  };

  canceledColumnStyling = (value: string) => {
    return value === "CANCELED" ? "canceled" : "";
  };


  imgOnclickFunction = (value: any) => {
    return <>hi</>
  }

  toggle(tab: string) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        columnNames: [
          { label: "contact", displayText: 1, columnStyling: "", orderId: 1, displayLabelText: "CONTACT" },
          { label: "interaction", displayText: 1, columnStyling: "", orderId: 2, displayLabelText: "INTERACTION" },
          { label: "dateCreated", displayText: 1, columnStyling: "", orderId: 3, displayLabelText: "DATE CREATED" },
          {
            label: "dateCompleted",
            displayText: 1,
            columnStyling: "",
            condition: this.canceledColumnStyling,
            orderId: 4,
            displayLabelText: "DATE COMPLETED"
          },
          {
            label: "action",
            displayText: 1,
            columnStyling: "",
            textStyling: "",
            orderId: 5,
            displayLabelText: "ACTION"
          },
          {
            label: "reassign",
            displayText: 1,
            columnStyling: "",
            textStyling: "",
            orderId: 6,
            displayLabelText: "ASSIGNED TO"
          },
          {
            label: "product",
            displayText: 1,
            columnStyling: "interactionHistory",
            textStyling: "",
            orderId: 7,
            displayLabelText: "PRODUCT"
          },
          {
            label: "actionNotes",
            displayText: 2,
            columnStyling: "optionsContainer",
            operation: this.imgOnclickFunction,
            orderId: 8,
            displayLabelText: "NOTES"
          },
          {
            label: "documents",
            displayText: 2,
            columnStyling: "optionsContainer",
            orderId: 9,
            displayLabelText: "DOCUMENTS"
          }
        ],
      });
      if (tab === "1") {
        this.setState({
          columnNames: [
            { label: "contact", displayText: 1, columnStyling: "", orderId: 1, displayLabelText: "CONTACT" },
            { label: "interaction", displayText: 1, columnStyling: "", orderId: 2, displayLabelText: "INTERACTION" },
            { label: "dateCreated", displayText: 1, columnStyling: "", orderId: 3, displayLabelText: "DATE CREATED" },
            {
              label: "dateCompleted",
              displayText: 1,
              columnStyling: "",
              condition: this.canceledColumnStyling,
              orderId: 4,
              displayLabelText: "DATE COMPLETED"
            },
            {
              label: "action",
              displayText: 1,
              columnStyling: "",
              textStyling: "",
              orderId: 5,
              displayLabelText: "ACTION"
            },
            {
              label: "reassign",
              displayText: 1,
              columnStyling: "",
              textStyling: "",
              orderId: 6,
              displayLabelText: "ASSIGNED TO"
            },
            {
              label: "product",
              displayText: 1,
              columnStyling: "interactionHistory",
              textStyling: "",
              orderId: 7,
              displayLabelText: "PRODUCT"
            },
            {
              label: "actionNotes",
              displayText: 2,
              columnStyling: "optionsContainer",
              operation: this.imgOnclickFunction,
              orderId: 8,
              displayLabelText: "NOTES"
            },
            {
              label: "documents",
              displayText: 2,
              columnStyling: "optionsContainer",
              orderId: 9,
              displayLabelText: "DOCUMENTS",
              condition: this.openFileViewer
            }
          ]
        });
      }
      if (tab === "2") {
        this.setState({
          columnNames: [
            {
              label: "name",
              displayText: 3,
              columnStyling: "loginLabel",
              textStyling: "",
              orderId: 1
            },
            { label: "sessionTime", displayText: 4, columnStyling: "", displayLabelText: "SESSION TIME", orderId: 2, removeMilliSeconds: removeMilliSeconds },
            { label: "sessionStart", displayText: 4, columnStyling: "sessionStart", displayLabelText: "SESSION START", orderId: 3, timeConversion: timeConversion },
            { label: "sessionEnd", displayText: 4, columnStyling: "", displayLabelText: "SESSION END", orderId: 4, timeConversion: timeConversion },
            {
              label: "date",
              displayText: 4,
              columnStyling: "lastColumn",
              textStyling: "",
              displayLabelText: "DATE",
              orderId: 5
            },
          ],
        });
      }
    }
  }
  getFiltersDataProperties = () => {
    const postData = {
      screen: "ProspectDetails",
      sections: "getIHFiltersDropdownsList",
      clientId: this.props.params.clientId,
      isJsonReturnObject: true,
    };
    this.service.getLeadsData(postData).then((res: any) => {
      this.setState({ filtersData: res.data });
    })
  }
  clearAllfiltervalues = () => {
    this.setState({ selectedFilters: null });
    clearFilters();
    this.getInteractionHistory(null);
  };

  filterModalHandler = () => {
    this.setState({ filterModal: true });
    // this.getFiltersDataProperties();
  }
  closeFilterHandler = () => {
    this.setState({ filterModal: false });
  }
  getFiltersDataHandler = (seletedFilters: any, filterFormValues: any) => {
    this.setState({ selectedFilters: filterFormValues });
    setFilters(this.state.pageName, filterFormValues)
    this.getInteractionHistory(seletedFilters);
    this.closeFilterHandler()
  }
  getFilterText = (selectedValues: any, type: string) => {
    if (type === "product") {
      return this.state.filtersData?.[0]?.products?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "interaction") {
      return this.state.filtersData?.[0]?.interactions?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "contact") {
      return this.state.filtersData?.[0]?.contacts?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "actions") {
      return this.state.filtersData?.[0]?.campaigns?.find(
        (m: any) => m.value == selectedValues.value
      )?.text;
    }
    if (type === "notesAndDocuments") {
      return notesAndDocumentsData?.find(
        (m: any) => m.value == selectedValues
      )?.text;
    }
    if (type === "date") {
      return moment(selectedValues).format("MM/DD/YYYY");
    }
  };
  clearProduct = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.products?.filter(
      (m: any) => m.id !== selectedID
    );
    this.setState({ selectedFilters: { ...this.state.selectedFilters, products: newSelectedFilters, } });
    setFilters(this.state.pageName, { ...this.state.selectedFilters, products: newSelectedFilters });
    const newFiltersData = {
      campaigns: this.state.selectedFilters?.campaigns?.map((m: any) => m.value),
      contacts: this.state.selectedFilters?.contacts?.map((m: any) => m.value),
      interactions: this.state.selectedFilters?.interactions?.map((m: any) => m.text),
      products: newSelectedFilters?.map((m: any) => m.value),
      notesAndDocuments: this.state.selectedFilters?.notesAndDocuments ?? null,
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getInteractionHistory(newFiltersData)
  };
  clearInteraction = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.interactions?.filter(
      (m: any) => m.id !== selectedID
    );
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        interactions: newSelectedFilters,
      },
    });
    setFilters(this.state.pageName, { ...this.state.selectedFilters, interactions: newSelectedFilters });
    const newFiltersData = {
      campaigns: this.state.selectedFilters?.campaigns?.map((m: any) => m.value),
      contacts: this.state.selectedFilters?.contacts?.map((m: any) => m.value),
      interactions: newSelectedFilters?.map((m: any) => m.text),
      products: this.state.selectedFilters?.products?.map((m: any) => m.value),
      notesAndDocuments: this.state.selectedFilters?.notesAndDocuments ?? null,
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getInteractionHistory(newFiltersData)
  };
  clearContacts = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.contacts?.filter(
      (m: any) => m.id !== selectedID
    );
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        contacts: newSelectedFilters,
      },
    });
    setFilters(this.state.pageName, { ...this.state.selectedFilters, contacts: newSelectedFilters });
    const newFiltersData = {
      campaigns: this.state.selectedFilters?.campaigns?.map((m: any) => m.value),
      contacts: newSelectedFilters?.map((m: any) => m.value),
      interactions: this.state.selectedFilters?.interactions?.map((m: any) => m.text),
      products: this.state.selectedFilters?.products?.map((m: any) => m.value),
      notesAndDocuments: this.state.selectedFilters?.notesAndDocuments ?? null,
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getInteractionHistory(newFiltersData)
  };
  clearActions = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.campaigns?.filter(
      (m: any) => m.id !== selectedID
    );
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        campaigns: newSelectedFilters,
      },
    });
    setFilters(this.state.pageName, { ...this.state.selectedFilters, campaigns: newSelectedFilters });

    const newFiltersData = {
      campaigns: newSelectedFilters?.map((m: any) => m.value),
      contacts: this.state.selectedFilters?.contacts?.map((m: any) => m.value),
      interactions: this.state.selectedFilters?.interactions?.map((m: any) => m.text),
      products: this.state.selectedFilters?.products?.map((m: any) => m.value),
      notesAndDocuments: this.state.selectedFilters?.notesAndDocuments ?? null,
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getInteractionHistory(newFiltersData)
  };
  clearNotesAndDocuments = (selectedID: any) => {
    const newSelectedFilters = this.state.selectedFilters?.notesAndDocuments?.filter(
      (m: any) => m !== selectedID
    );
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        notesAndDocuments: newSelectedFilters
      },
    });
    setFilters(this.state.pageName, { ...this.state.selectedFilters, notesAndDocuments: newSelectedFilters });

    const newFiltersData = {
      notesAndDocuments: newSelectedFilters,
      campaigns: this.state.selectedFilters?.campaigns?.map((m: any) => m.value),
      contacts: this.state.selectedFilters?.contacts?.map((m: any) => m.value),
      interactions: this.state.selectedFilters?.interactions?.map((m: any) => m.text),
      products: this.state.selectedFilters?.products?.map((m: any) => m.value),
      date: this.state.selectedFilters?.date
        ? moment(this.state.selectedFilters?.date).format("MM/DD/YYYY")
        : null,
    };
    this.getInteractionHistory(newFiltersData)
  }
  clearDate = (selectedID: any) => {
    if (this.state.selectedFilters?.date === selectedID) {
      this.setState({
        selectedFilters: {
          ...this.state.selectedFilters,
          date: null,
        },
      });
      setFilters(this.state.pageName, { ...this.state.selectedFilters, date: null });

      const newFiltersData = {
        campaigns: this.state.selectedFilters?.campaigns?.map((m: any) => m.value),
        contacts: this.state.selectedFilters?.contacts?.map((m: any) => m.value),
        interactions: this.state.selectedFilters?.interactions?.map((m: any) => m.text),
        products: this.state.selectedFilters?.products?.map((m: any) => m.value),
        notesAndDocuments: this.state.selectedFilters?.notesAndDocuments ?? null,
      };
      this.getInteractionHistory(newFiltersData)
    }
  };


  setViewFile = () => {
    this.setState({ viewFile: !this.state.viewFile })
  }

  cancelTileStytling = (column: any) => {
    if (column.dateCompleted === "CANCELED") return "CancelTile"
    else return ""
  }
  render() {
    const { filterModal, filtersData, selectedFilters, documentsData } = this.state;
    return (
      <>
        {this.state.loader && <FinSpinner />}
        <div className="history-tabs">
          <Nav tabs>
            <NavItem>
              <NavLink onClick={() => this.toggle("1")} className={`${this.state.activeTab == "1" && "activeTab"}`}>
                Completed Actions
              </NavLink>
            </NavItem>
            <NavItem>
              {withContext(this.context, Pages.customerDetailsPage, actionAuthorization.viewCustomerActivities, this.props.context?.productDetails?.productid) && <NavLink onClick={() => {
                this.toggle("2")
                this.getClientActivityData()
              }} className={`${this.state.activeTab == "2" && "activeTab"}`}>
                Customer Activity
              </NavLink>}
            </NavItem>
          </Nav>
          {this.state.activeTab === "1" &&
            <div className="detailsPage-filters-wrap">
              {selectedFilters?.products?.map((m: any, index: number) => (
                <span className="filteredText" key={index}>
                  {this.getFilterText(m, "product")}{" "}
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => this.clearProduct(m.id)}
                  />{" "}
                </span>
              ))}
              {selectedFilters?.interactions?.map((m: any, index: number) => (
                <span className="filteredText" key={index}>
                  {this.getFilterText(m, "interaction")}{" "}
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => this.clearInteraction(m.id)}
                  />{" "}
                </span>
              ))}
              {selectedFilters?.contacts?.map((m: any, index: number) => (
                <span className="filteredText" key={index}>
                  {this.getFilterText(m, "contact")}{" "}
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => this.clearContacts(m.id)}
                  />{" "}
                </span>
              ))}
              {selectedFilters?.campaigns?.map((m: any, index: number) => (
                <span className="filteredText" key={index}>
                  {this.getFilterText(m, "actions")}{" "}
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => this.clearActions(m.id)}
                  />{" "}
                </span>
              ))}
              {selectedFilters?.notesAndDocuments?.map((m: any, index: number) => (
                <span className="filteredText" key={index}>
                  {this.getFilterText(m, "notesAndDocuments")}{" "}
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => this.clearNotesAndDocuments(m)}
                  />{" "}
                </span>
              ))}
              {selectedFilters?.date ? (
                <span className="filteredText">
                  {this.getFilterText(selectedFilters?.date, "date")}{" "}
                  <FontAwesomeIcon
                    icon={faTimes}
                    onClick={() => this.clearDate(selectedFilters?.date)}
                  />{" "}
                </span>
              ) : (
                ""
              )}
              <Button className="filtersBtn-detailsPage-interactionHistory" onClick={this.filterModalHandler}>
                <img src={FilterIcon} alt="FilterIcon" className="filter-icon" />
                <span className="filter-text">Filters</span>
              </Button>
            </div>}
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <DynamicListView
                tilesData={this.state.completedActions}
                columnNames={this.state.columnNames}
                className={"customerTile"}
                cancelTileStytling={this.cancelTileStytling}
              />
            </TabPane>
            <TabPane tabId="2">
              <DynamicListView
                tilesData={this.state.customerActivity}
                columnNames={this.state.columnNames}
                className={"customerActivityTile"}
              />
            </TabPane>
          </TabContent>
          {/* Modal for filter */}
          <ModalPopup
            show={filterModal}
            onHide={this.filterModalHandler}
            className="filter-modal interactionModal"
            autoFocus={false}
          >
            <ModalPopup.Header closeButton onClick={this.closeFilterHandler}>
              Filters
            </ModalPopup.Header>
            <ModalPopup.Body>
              <FilterLeads
                getFiltersDataHandler={this.getFiltersDataHandler}
                filtersData={filtersData}
                filterType="detailsPageFilters"
                notesAndDocumentsData={notesAndDocumentsData}
                selectedFilters={selectedFilters}
                clearAllfiltervalues={this.clearAllfiltervalues}
              />
            </ModalPopup.Body>
          </ModalPopup>
          <div className="fileViewerModalContainer">
            <Modal
              className=" mw-100 w-50 fileViewerModalWrapper messageCenterFileView"
              isOpen={this.state.viewFile}
              fade={false}
              toggle={() => this.setViewFile()}
            >
              <ModalHeader toggle={() => this.setViewFile()}>
                <Row className="customHeader modal-title">
                  <Col>
                    <div
                      className={`fileHeader`}
                    // onClick={() => setReadMore(prev => !prev)}
                    >
                      {documentsData?.fileName}
                    </div>
                  </Col>
                </Row>
                <Row></Row>
              </ModalHeader>
              <ModalBody>
                <div className="TC_fileView">
                  {documentsData ? (
                    // <FileViewer files={[documentsData]} disableHeader={true} />
                    <ReactFileViewer
                      fileDocument={documentsData}
                    />
                  ) : <></>}
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
      </>
    );
  }
}


export default withRouter<WithRouterProps<initialProps>>(InteractionHistoryMainCC)